<template>
  <div>{{ displayValue }}</div>
</template>
<script>
export default {
  props: {
    start: {
      type: Number,
      required: false,
      default: 0
    },
    end: {
      type: Number,
      required: false,
      default: 2022
    },
    duration: {
      type: Number,
      required: false,
      default: 2000
    },
    autoPlay: {
      type: Boolean,
      required: false,
      default: true
    },
    decimals: {
      type: Number,
      required: false,
      default: 0,
      validator(value) {
        return value >= 0
      }
    },
    decimal: {
      type: String,
      required: false,
      default: '.'
    },
    separator: {
      type: String,
      required: false,
      default: ','
    },
    prefix: {
      type: String,
      required: false,
      default: ''
    },
    suffix: {
      type: String,
      required: false,
      default: ''
    },
    useEasing: {
      type: Boolean,
      required: false,
      default: true
    },
    easingFn: {
      type: Function,
      default(t, b, c, d) {
        return (c * (-Math.pow(2, (-10 * t) / d) + 1) * 1024) / 1023 + b
      }
    }
  },
  data() {
    return {
      localStart: this.start,
      displayValue: this.formatNumber(this.start),
      printVal: null,
      paused: false,
      localDuration: this.duration,
      startTime: null,
      timestamp: null,
      remaining: null,
      rAF: null
    }
  },
  computed: {
    stopCount() {
      return this.start > this.end
    }
  },
  watch: {
    start: 'startCount',
    end: 'endCount'
  },
  methods: {
    isNumber(val) {
      return !isNaN(parseFloat(val))
    },
    formatNumber(val) {
      val = val.toFixed(this.decimals)
      val += ''
      const x = val.split('.')
      let x1 = x[0]
      const x2 = x.length > 1 ? this.decimal + x[1] : ''
      const rgx = /(\d+)(\d{3})/
      if (this.separator && !this.isNumber(this.separator)) {
        // while (rgx.test(x1)) {
        //   x1 = x1.replace(rgx, '$1' + this.separator + '$2')
        // }
      }
      return this.prefix + x1 + x2 + this.suffix
    },
    startCount() {
      this.localStart = this.start
      this.startTime = null
      this.localDuration = this.duration
      this.paused = false
      this.rAF = requestAnimationFrame(this.count)
    },
    endCount() {
      if (!this.end) {
        this.rAF = 0
      }
      if (this.autoPlay) {
        this.end = Number(this.end)
        this.startCount()
      }
    },
    count(timestamp) {
      if (!this.startTime) this.startTime = timestamp
      this.timestamp = timestamp
      const progress = timestamp - this.startTime
      this.remaining = this.localDuration - progress
      if (this.useEasing) {
        if (this.stopCount) {
          this.printVal =
            this.localStart - this.easingFn(progress, 0, this.localStart - this.end, this.localDuration)
        } else {
          this.printVal = this.easingFn(progress, this.localStart, this.end - this.localStart, this.localDuration)
        }
      } else {
        if (this.stopCount) {
          this.printVal = this.localStart - (this.localStart - this.end) * (progress / this.localDuration)
        } else {
          this.printVal = this.localStart + (this.end - this.localStart) * (progress / this.localDuration)
        }
      }
      if (this.stopCount) {
        this.printVal = this.printVal < this.end ? this.end : this.printVal
      } else {
        this.printVal = this.printVal > this.end ? this.end : this.printVal
      }
      this.displayValue = this.formatNumber(this.printVal)
      if (progress < this.localDuration) {
        this.rAF = requestAnimationFrame(this.count)
      } else {
        this.$emit('callback')
      }
    }
  },
  mounted() {
    if (this.autoPlay) {
      this.startCount()
    }
    this.$emit('onMountedcallback')
  },
  beforeDestroy() {
    cancelAnimationFrame(this.rAF)
  }
}
</script>